import React, { PropsWithChildren } from "react";
import { Icon } from "semantic-ui-react";
import { SemanticICONS } from "semantic-ui-react/dist/commonjs/generic";
import { IFileUploadElementProps } from "../../../../../sg-fileupload";
import "./_InputElement.less";

interface InputElementProps extends IFileUploadElementProps {
    text: string;
    icon: SemanticICONS;
}

export const InputElement: React.FC<PropsWithChildren<InputElementProps>> = ({
    children,
    isDragActive,
    text,
    icon = "file"
}) => {

    return (
        <div className={`drop zone ${isDragActive && "loading"}`}>
            <div className="drop icon">
                <Icon.Group size="big">
                    <Icon name="circle outline" size="large" fitted color="grey" />
                    <Icon name={icon} size="small" color="grey" />
                </Icon.Group>
            </div>
            <div className="drop text">
                {text}
                {children}
            </div>
        </div>
    );
};
